// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formTable__label[data-v-5f40f0da] {\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
